'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

require('./PreviewModal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviewModal = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(PreviewModal, _Component);

  function PreviewModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PreviewModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PreviewModal.__proto__ || (0, _getPrototypeOf2.default)(PreviewModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      imageRatio: 1,
      loading: true
    }, _this.componentWillReceiveProps = function (nextProps) {
      if (!_this.props.visible && nextProps.visible) {
        var img = new Image();
        img.onload = function (e) {
          var imageRatio = e.target.width / e.target.height;
          _this.setState({
            imageRatio: imageRatio,
            loading: false
          });
        };
        img.src = nextProps.imageUrls[0];
      }
    }, _this.componentDidUpdate = function (prevProps, prevState) {
      if (_this.carouselRef && !prevProps.visible && _this.props.visible) {
        // HACKY - When closing modal, there seems to be a bug with the innerSlider in Carousel, where it is incorrectly setting currentSlide index
        // This happens when we change imageUrls to empty (on close). - JT
        _this.carouselRef.innerSlider.setState({ currentSlide: 0 });
      }
    }, _this.buildContent = function () {
      return _this.props.imageUrls.map(function (url) {
        return _react2.default.createElement(
          'div',
          { key: url },
          _react2.default.createElement('img', { src: url, alt: 'Preview' })
        );
      });
    }, _this.onCancel = function () {
      _this.props.onCancel();
      _this.setState({
        loading: true
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PreviewModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var visible = this.props.visible;

      var modalHeight = window.innerHeight - 25;

      var modalTopMargin = 20; // margin modal is from top of window
      var modalPadding = 16 * 2; // padding, both top and bottom of modal
      var topXIconPadding = 25; // padding within modal to allow for x-icon spacing
      var modalSidePadding = 32; // padding on the sides of the image
      var effectiveImageHeight = modalHeight - modalTopMargin - modalPadding - topXIconPadding;
      if (this.state.loading) return null;
      return _react2.default.createElement(
        _antd.Modal,
        {
          title: 'Preview',
          visible: visible,
          onCancel: this.onCancel,
          closable: true,
          style: { top: 20 },
          height: modalHeight,
          width: effectiveImageHeight * this.state.imageRatio + modalSidePadding,
          wrapClassName: 'Preview__Modal',
          footer: null
        },
        _react2.default.createElement(
          'div',
          { className: 'carousel-container' },
          _react2.default.createElement(
            _antd.Carousel,
            {
              ref: function ref(_ref2) {
                _this2.carouselRef = _ref2;
              }
            },
            this.buildContent()
          )
        )
      );
    }
  }]);
  return PreviewModal;
}(_react.Component), _class.propTypes = {
  imageUrls: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  visible: _propTypes2.default.bool.isRequired,
  onCancel: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = PreviewModal;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/components/PreviewModal/index.js
// module id = 3909
// module chunks = 5 6 7 8